// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss';

// Translatable strings
const strings = UncannyAutomator._core.i18n.components.item;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-menu-button-delete' )
export class AutomatorBuilderItemMenuButtonDelete extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// The item type (e.g. `"trigger"`)
	@property( { type: String, attribute: 'item-type' } ) accessor itemType;

	// The item ID (post ID)
	@property( { type: Number, attribute: 'item-id' } ) accessor itemID;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-button
				color="transparent"
				@click=${ this.handleItemDelete }
			>
				${ strings.delete }
			</uo-button>
		`;
	}

	/**
	 * Handles the item deletion
	 */
	handleItemDelete() {
		UncannyAutomator._core.recipe.item.deleteItem(
			this.itemType,
			this.itemID
		).then( response => {
			console.log( response );
		} ).catch( error => {
			console.log( error );
		} );
	}
}
